<template>

  <div>
    <!--v-bind= "nome do objeto"-->
    <!--Barra de pesquisa-->
    <default-form-validation-provider label="Perfil de acesso" v-slot="defaultState">
      <multiselect v-model="Perfis.Descricao" :state="defaultState.state" placeholder="Selecione um perfil"
        :options="computedPerfis" label="Descricao" track-by="Id" :allow-empty="true" v-bind="multiselectprops"
        @select="adicionarPerfil">
        <template slot="noOptions">
          <small><i>Erro ao obter dados.</i></small>
        </template>
        <template slot="noResult">
          <i>Sem resultados.</i>
        </template>
      </multiselect>
    </default-form-validation-provider>
    <div>

      <b-table striped hover stacked="md" show-empty :items="listaPerfisSelecionados" :fields="computedFields">
        <template #empty>
          <span>Nenhum perfil foi selecionado.</span>
        </template>
        <template slot="cell(actions)" slot-scope="perfilData">
          <b-button size="sm" @click="removerItemPerfil(perfilData.item)">
            <font-awesome-icon icon="trash" />
          </b-button>
        </template>
        <template #head(actions)>
          <div>
            <!--Botão para remover todos os perfis-->
            <b-button size="sm" @click="removerPerfis">
              <font-awesome-icon icon="ban" />
            </b-button>
          </div>
        </template>
      </b-table>
    </div>

  </div>

</template>

<script lang="ts">
import { mixins } from 'vue-class-component';
import { UtilsTS } from '@/utilsts';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { Perfil } from '@/types/administracao/cadastro-permissoes/perfil';
import perfisService from '@/services/administracao/perfisService';
import { store } from "@/store";
import Multiselect from "vue-multiselect";
import { MultiSelectDefaultProps } from '@/types/form-default-props'
import DefaultFormValidationProvider from '@/components/shared/DefaultFormValidationProvider.vue';
import { PropType } from 'vue';

const CompProps = Vue.extend({
  name: 'SeletorDePerfis',
  components: { Multiselect, DefaultFormValidationProvider },
  props: {
    perfisSelecionados: {
      type: Array as PropType<Perfil[]>,
      required: true
    },
    perfisUsuarioUG: {
      type: Array as PropType<perfilUG[]>,
      required: true
    },
    cin: {
      type: Boolean
    }




  }
})

interface perfilUG {
  ID_USUARIO_PERFIL: number;
  DESCRICAO: string;
  ID: string;

}



@Component
export default class SeletorDePerfis extends mixins(UtilsTS, CompProps) {
  multiselectprops = MultiSelectDefaultProps;
  listaPerfis: Perfil[] = [];
  listaPerfisSelecionados: Perfil[] = []
  listaPerfisUG: perfilUG[] = []
  Perfis: Perfil = new Perfil()





  async mounted() {
    try {
      store.blockScreen = true
      this.carregarPerfis()
    } catch (e) {
      console.error(e)
    } finally {
      store.blockScreen = false
    }
    this.listaPerfisUG = this.perfisUsuarioUG
    //console.log(this.listaPerfisUG)
  }



  @Watch('perfisSelecionados', { deep: true })
  onListaChange() {
    if (this.perfisSelecionados.length === 0 && this.listaPerfisSelecionados.length > 0) {

      this.removerPerfis()
    }

  }






  get computedPerfis() {
    let filtro1: Perfil[] = this.listaPerfis
    let listaPerfisFiltrados: Perfil[] = []

    //primeio filtro

    for (let i = 0; i < filtro1.length; i++) {
      for (let j = 0; j < this.listaPerfisUG.length; j++) {
        if (this.listaPerfisUG[j].ID === String(filtro1[i].Id)) {
          filtro1.splice(i, 1)
        }
      }
    }

    //segundo filtro
    listaPerfisFiltrados = filtro1.filter(item => !this.perfisSelecionados.includes(item));
    //console.log(listaPerfisFiltrados)
    return listaPerfisFiltrados
  }



  get computedFields() {
    const fields = [{ key: 'Descricao', label: 'Perfis selecionados' }];
    if (this.listaPerfisSelecionados.length > 0) {
      fields.push({ key: 'actions', label: '' });
    }
    return fields;
  }

  //Buscar Perfis
  async carregarPerfis() {
    try {
      if (this.cin === true) {
        this.listaPerfis = await perfisService.listarPerfis('S')
      } else {
        this.listaPerfis = await perfisService.listarPerfis()
      }

      //console.log(this.listaPerfis)
    } catch (e: any) {
      this.tratarError(e)
    }
  };

  adicionarPerfil(perfil: Perfil) {
    if (!this.listaPerfisSelecionados.includes(perfil)) {
      this.listaPerfisSelecionados.push(perfil);
    }
    //emit feito para alterar a lista no componente pai
    this.$emit('AdicionandoPerfil', this.listaPerfisSelecionados)
  };

  //remover um item específico da lista de perfis selecionados
  removerItemPerfil(item: Perfil) {
    this.listaPerfisSelecionados = this.listaPerfisSelecionados.filter(perfil => perfil.Id !== item.Id);
    //emit feito para alterar a lista no componente pai
    this.$emit('removendoPerfil', this.listaPerfisSelecionados)
  }

  //remove todos os perfis
  removerPerfis() {
    this.listaPerfisSelecionados = []
    //emit feito para alterar a lista no componente pai
    this.$emit('removerPerfis')
  }
}

</script>